import * as React from 'react';
import { AppTeachingBubbleProps } from "./AppTeachingBubble.props";
import { TeachingBubble } from 'office-ui-fabric-react';

/**
 * Teaching Bubble
 * @param props Teaching bubble component properties
 */
export const AppTeachingBubble: React.FunctionComponent<AppTeachingBubbleProps> = (props: AppTeachingBubbleProps): JSX.Element => {
    const { target, calloutProps, hasCloseButton, hasCloseIcon, hasSmallHeadline,
        headline, isWide, onDismiss, primaryButtonProps,
        secondaryButtonProps, text, styles, focusTrapZoneProps, closeButtonAriaLabel } = props;
    
    return (
    <TeachingBubble
        target = {target}
        calloutProps = {calloutProps}
        hasCloseButton = {hasCloseButton}
        closeButtonAriaLabel = {closeButtonAriaLabel}
        hasCloseIcon = {hasCloseIcon}
        hasSmallHeadline = {hasSmallHeadline}
        headline = {headline}
        isWide = {isWide}
        onDismiss = {onDismiss}
        primaryButtonProps={primaryButtonProps}
        secondaryButtonProps={secondaryButtonProps}
        focusTrapZoneProps={focusTrapZoneProps}
        styles = {styles}
      >{text}</TeachingBubble>
      );
}